import moment from "moment";

//秒数转化为几分几秒
export function formatSeconds(value) {
  if(value === undefined || value === ''){
    return '';
  }
  let hours = Math.floor(parseFloat(value) / 3600);
  let remainingSeconds = parseFloat(value) % 3600;
  let minutes = Math.floor(parseFloat(remainingSeconds) / 60);
  remainingSeconds = Math.floor(parseFloat(remainingSeconds) % 60);
  let timeStr = '';
  if(hours === 0){
    if(minutes=== 0){
      timeStr = `${remainingSeconds}秒`;
    }else{
      if(remainingSeconds=== 0){
        timeStr = `${minutes}分钟`;
      }else{
        timeStr = `${minutes}分${remainingSeconds}秒`;
      }
    }
  }else{
    if(minutes=== 0){
      if(remainingSeconds!== 0){
        timeStr = `${hours}小时${remainingSeconds}秒`;
      }else{
        timeStr = `${hours}小时`;
      }
    }else{
      if(remainingSeconds=== 0){
        timeStr = `${hours}小时${minutes}分`;
      }else{
        timeStr = `${hours}小时${minutes}分${remainingSeconds}秒`;
      }
    }
  }
  return timeStr;
}

export function formatTime(value) {
  return moment(new Date(value)).format("YYYY-MM-DD HH:mm:ss");
}

export function determineExists(value) {
  if (value === null || value === undefined || value === "") {
    return false;
  } else {
    return true;
  }
}
